import { htmlSafe } from '@ember/template';
import { helper as buildHelper } from '@ember/component/helper';
import { escape } from 'lodash';

export default buildHelper(function (value) {
  return htmlSafe("background-image: url('" + escape(value[0]) + "');");
});
